import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import AirportList from './AirportList';
import { Link } from 'react-router-dom';

let permisionActions = [];

export default class Airports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.airportState.pageSize,
                pageIndex: this.props.airportState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.AIRPORT);
        this.props.getListAirports(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, airports } = this.props.airportState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'airports'}
                        titleHeader={t('navigation.airports')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.AIRPORT.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <AirportList loading={isFetching}
                                  permisions={permisionActions}
                                  airports={airports}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteAirport}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getListAirports(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListAirports(newFilters);
    }

    onDeleteAirport = (item) => {
        this.props.deleteAirportDetail(item, {
            filters: {
                pageSize: this.props.airportState.pageSize,
                pageIndex: this.props.airportState.pageIndex
            }
        });
    }
}

